import { Stack } from "@mui/joy";
import PCSideTab from "./PCSideTab";
import SidebarForPatient from "./SidebarForPatient";
import useIsInappWebview from "hooks/useIsInappWebview";
import { pcSideTabAtom } from "../../recoil/pcSideTabAtom";
import { useRecoilValue } from "recoil";

export default function SideBarLayoutForPatient() {
  const pcSideTab = useRecoilValue(pcSideTabAtom);

  const isInappWebview = useIsInappWebview();

  return isInappWebview ? (
    <SidebarForPatient isHome={window.location.pathname === "/"} />
  ) : (
    <Stack direction="row" sx={{ height: "100vh", overflow: "hidden" }}>
      <PCSideTab />
      {pcSideTab === "home" ? (
        <SidebarForPatient isHome={window.location.pathname === "/"} />
      ) : (
        <></>
      )}
    </Stack>
  );
}
